import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Navbar.module.css';

const Navbar = () => {
  const { i18n } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navbarRef = useRef(null);
  const lang = i18n.language === 'tr' ? 'tr' : 'en';

  const changeLanguage = (lang) => {
    localStorage.setItem('rux_language', lang);
    i18n.changeLanguage(lang);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };


  // Dışa tıklama ile menüyü kapat
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav className={styles.navbar} ref={navbarRef}>
      <div className={styles.navbarContainer}>
        {/* Logo */}
        <div className={styles.logo}>
          <div className={styles.logoImg}>
            <img src="/images/ruxLogo-40.png" alt="Rux Engine" className={styles.logoImage} />
          </div>
          <span className={styles.logoText}>RuX Engine</span>
        </div>

        {/* Desktop Menu */}
        <ul className={styles.menu}>
          <li className={styles.menuItem}><a href="#features" className={styles.menuLink}>{lang === 'tr' ? 'Özellikler' : 'Features'}</a></li>
          <li className={styles.menuItem}><a href="#pricing" className={styles.menuLink}>{lang === 'tr' ? 'Fiyatlandırma' : 'Pricing'}</a></li>
          <li className={styles.menuItem}><a href="#faq" className={styles.menuLink}>{lang === 'tr' ? 'SSS' : 'FAQs'}</a></li>
        </ul>

        {/* Hamburger */}
        <div
          className={`${styles.hamburger} ${isMobileMenuOpen ? styles.active : ''}`}
          onClick={toggleMobileMenu}
        >
          <div className={styles.hamburgerLine}></div>
          <div className={styles.hamburgerLine}></div>
          <div className={styles.hamburgerLine}></div>
        </div>

        {/* Right Section - Desktop */}
        <div className={styles.navRight}>
          <div className={styles.languageToggle}>
            <button
              onClick={() => changeLanguage('en')}
              className={`${styles.langBtn} ${lang === 'en' ? styles.active : ''}`}
            >
              EN
            </button>

            <button
              onClick={() => changeLanguage('tr')}
              className={`${styles.langBtn} ${lang === 'tr' ? styles.active : ''}`}
            >
              TR
            </button>
          </div>
          <div className={styles.authButtons}>
            <a href="/login" className={`${styles.btn} ${styles.btnLogin}`}>{lang === 'tr' ? 'Giriş Yap' : 'Login'}</a>
            <a href="/register" className={`${styles.btn} ${styles.btnRegister}`}>{lang === 'tr' ? 'Kayıt Ol' : 'Register'}</a>
          </div>
        </div>
      </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className={styles.mobileMenu}>
            <div className={styles.mobileMenuContent}>
              <div className={styles.mobileMenuItem}>
                <a href="#features" className={styles.mobileMenuLink}>{lang === 'tr' ? 'Özellikler' : 'Features'}</a>
              </div>
              <div className={styles.mobileMenuItem}>
                <a href="#pricing" className={styles.mobileMenuLink}>{lang === 'tr' ? 'Fiyatlandırma' : 'Pricing'}</a>
              </div>
              <div className={styles.mobileMenuItem}>
                <a href="#faq" className={styles.mobileMenuLink}>{lang === 'tr' ? 'SSS' : 'FAQs'}</a>
              </div>
              <div className={styles.mobileLanguage}>
                <div className={styles.languageToggle}>
                  <button
                    onClick={() => changeLanguage('en')}
                    className={`${styles.langBtn} ${lang === 'en' ? styles.active : ''}`}
                  >
                    EN
                  </button>

                  <button
                    onClick={() => changeLanguage('tr')}
                    className={`${styles.langBtn} ${lang === 'tr' ? styles.active : ''}`}
                  >
                    TR
                  </button>
                </div>
              </div>
              <div className={styles.mobileAuth}>
                <a href="/login" className={`${styles.btn} ${styles.btnLogin}`}>{lang === 'tr' ? 'Giriş Yap' : 'Login'}</a>
                <a href="/register" className={`${styles.btn} ${styles.btnRegister}`}>{lang === 'tr' ? 'Kayıt Ol' : 'Register'}</a>
              </div>
            </div>
          </div>
        )}
    </nav>
  );
};

export default Navbar;
